import React, { useState } from "react";
import verifyOtpImg from "../../../assets/img/verify-otp.svg";
import ezycompLogo from "../../../assets/img/logo.png";
import { preventDefault } from "../../../utils/common";
import FormRenderer, { ComponentMapper, FormTemplate } from "../../common/FormRenderer";
import { LOGIN_FIELDS } from "./Authenticate.constants";
import { useVerifyOTP, useResendOTP } from "../../../backend/auth";
import { toast } from "react-toastify";
import PageLoader from "../../shared/PageLoader";
import { ERROR_MESSAGES } from "../../../utils/constants";

interface PostLoginOTPProps {
    onSuccess: (token: string) => void;
    onCancel: () => void;
    username: string;
    email: string;
}

function PostLoginOTP({ onSuccess, onCancel, username, email }: PostLoginOTPProps) {
    const [form, setForm] = useState<any>({});
    
    const { verifyOTP, isLoading } = useVerifyOTP((response: any) => {
        if (response && response.data && response.data.token) {
            onSuccess(response.data.token);
        } else {
          response = response.response ? response.response : response
            const errorMessage = (response && response.data && response.data.error) || ERROR_MESSAGES.ERROR;
            toast.error(errorMessage);
        }
    }, (error: any) => {
        error = error.response ? error.response : error;
        const errorMessage = (error && error.data && error.data.error) || ERROR_MESSAGES.DEFAULT;
        toast.error(errorMessage);
    });

    const { resendOTP, isLoading: isResending } = useResendOTP((response: any) => {
        if (response && response.data) {
            toast.success("OTP resent successfully to your registered email");
        } else {
            response = response.response ? response.response : response
            const errorMessage = (response && response.data && response.data.error) || "Failed to resend OTP";
            toast.error(errorMessage);
        }
    }, (err: any) => {
        console.log(err)
        toast.error("Failed to resend OTP. Please try again.");
    });

    const schema = {
        fields: [{ ...LOGIN_FIELDS.OTP }]
    };

    function handleVerifyOTP({ otp }: any) {
        if (form.valid) {
            verifyOTP({ username, otp });
        }
    }

    function handleCancel(event: any) {
        preventDefault(event);
        onCancel();
    }

    function handleResendOTP(event: any) {
        preventDefault(event);
        resendOTP({username});
    }

    return (
        <>
            <div className="row m-0 overflow-hidden">
                <div className="col-md-8 p-0 bannerSlider d-flex align-items-center justify-content-center bg-light">
                    <div className="text-center">
                        <img src={verifyOtpImg} alt="VERIFY OTP" height="200px" className="mb-4" />
                        <h3 className="text-muted">Almost there!</h3>
                        <p className="text-muted">Please verify the OTP sent to your registered email to complete the login process.</p>
                    </div>
                </div>

                <div className="col-md-4 loginSection px-5 py-3">
                    <div className="d-flex flex-column h-100 justify-content-between align-items-center mt-5">
                        <div className="d-flex flex-column justify-content-center align-items-center">
                            <div className="navbar-brand p-0 text-center mb-4">
                                <img src={ezycompLogo} alt="Logo" width="344" />
                            </div>
                            <div className="col-9" style={{ minHeight: '250px' }}>
                                <div className="text-center mb-4">
                                    <h5 className="text-xl text-black-600">Verify OTP</h5>
                                    <p className="text-sm text-muted">OTP sent to your registered email</p>
                                </div>
                                
                                <FormRenderer 
                                    FormTemplate={FormTemplate}
                                    initialValues={{ submitBtnText: 'Verify OTP', fullWidth: false }}
                                    componentMapper={ComponentMapper}
                                    schema={schema}
                                    debug={setForm}
                                    onSubmit={handleVerifyOTP}
                                    clearOnUnmount={true}
                                />
                                
                                <div className="mt-3 text-center">
                                    <small className="text-muted">OTP expires in 5 minutes</small>
                                </div>
                                
                                <div className="text-center mt-3">
                                    <a 
                                        href="/" 
                                        onClick={handleResendOTP} 
                                        className={`text-appprimary ${isResending ? 'text-muted' : ''}`}
                                        style={{ pointerEvents: isResending ? 'none' : 'auto' }}
                                    >
                                        <small>{isResending ? 'Resending...' : 'Resend OTP'}</small>
                                    </a>
                                </div>

                                <div className="text-center mt-2">
                                    <a href="/" onClick={handleCancel} className="text-secondary">
                                        <small>Back to Login</small>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="">
                            <div className="card"></div>
                        </div>
                    </div>
                </div>
            </div>
            {
                (isLoading || isResending) && (
                    <PageLoader>
                        {isLoading && <p>Verifying OTP...</p>}
                        {isResending && <p>Resending OTP...</p>}
                    </PageLoader>
                )
            }
        </>
    );
}

export default PostLoginOTP;
